import { FTMARKETINGPAGES } from "../../../utils/featuresMarketingPage"

export const DotsFeatures2 = FTMARKETINGPAGES.map(ft => ({
    icon: ft.iconPath,
    text: ft.primaryText
}));